import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { nlNL } from '@mui/x-date-pickers/locales';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Router from 'router';
import { AxiosClientsProvider } from 'shared/axios/axios-clients-provider';
import ConfirmationPopupProvider from 'shared/components/confirmation-pop-up/providers/confirmation-popup-provider';
import ErrorMessage from 'shared/components/error/error-message';
import AuthProvider from 'shared/features/auth/authentication/providers/auth-provider';
import { LoggingProvider } from 'shared/logging/providers/logging.provider';
import { SubscriptionInfoProvider } from 'shared/providers/subscription-info/context/subscription-info-provider';

import { SignalRProvider } from 'features/signalr/context/signalr-provider';

import 'moment/dist/locale/nl';

import { reactPlugin } from './app-insights';

import './app.scss';

import ConfirmationPopUp from 'shared/components/confirmation-pop-up/confirmation-popup';
import ErrorMessageProvider from 'shared/components/error/providers/error-message-provider';
import { ConnectorProvider } from 'shared/providers/connector/context/connector-provider';
import { ActiveTenantFeatureSubscriptionsProvider } from 'shared/providers/tenant-feature-subscriptions/context/active-tenant-feature-subscriptions-provider';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const App = (): React.JSX.Element => (
  <LocalizationProvider
    dateAdapter={AdapterMoment}
    adapterLocale="nl"
    localeText={nlNL.components.MuiLocalizationProvider.defaultProps.localeText}
  >
    <AppInsightsContext.Provider value={reactPlugin}>
      <QueryClientProvider client={queryClient}>
        <AxiosClientsProvider>
          <AuthProvider>
            <SubscriptionInfoProvider>
              <SignalRProvider>
                <ConfirmationPopupProvider>
                  <LoggingProvider>
                    <ErrorMessageProvider>
                      <ActiveTenantFeatureSubscriptionsProvider>
                        <ConnectorProvider>
                          <div className="App">
                            <Router />
                            <ErrorMessage />
                            <ConfirmationPopUp />
                          </div>
                        </ConnectorProvider>
                      </ActiveTenantFeatureSubscriptionsProvider>
                    </ErrorMessageProvider>
                  </LoggingProvider>
                </ConfirmationPopupProvider>
              </SignalRProvider>
            </SubscriptionInfoProvider>
          </AuthProvider>
        </AxiosClientsProvider>
      </QueryClientProvider>
    </AppInsightsContext.Provider>
  </LocalizationProvider>
);

export default App;
